import React from 'react';
import { isMobile } from '@/utils';

function ServiceStep(props) {
  if (isMobile()) {
    const Mobile = require('./ServiceStep').default;
    return <Mobile {...props} />;
  }
  const Web = require('./WebServiceStep').default;
  return <Web {...props} />;
}

export default ServiceStep;
